export const Messages = {
  SOMETHING_WENT_WRONG: 'Ooops, something went wrong',
};
